import PropTypes from 'prop-types';
import Swal from 'sweetalert2';
import API, { APIPropTypes } from '../axios';

// Author Information
/**
 * Author: Deepak Chaurasiya
 * Email: deepak.chaurasiya@indusnet.co.in
 */

export class BrandManager {
  /**
   * Set the position of a template
   *
   * @param {Object} params - Parameters for setting template position
   * @param {string} params.name - Brand Manager Name
   * @param {string} params.email - Barand Manager Email
   * @returns {Promise} - Promise representing the response
   */
  async saveUserDetail({ name, email }) {
    try {
      const response = await API.post(`/api/bm/save_user_detail`, {
        name,
        email,
      });
      return response;
    } catch (error) {
      throw error;
    }
  }
}

// Prop Types for the Template class
BrandManager.propTypes = {
  getTemplateList: PropTypes.func,
  setTemplatePosition: PropTypes.func,
};

// Author Information Prop Types
BrandManager.authorPropTypes = {
  name: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
};

// Set Author Information
BrandManager.author = {
  name: 'Deepak Chaurasiya',
  email: 'deepak.chaurasiya@indusnet.co.in',
};

// Prop Types for the API module
API.propTypes = APIPropTypes;
